import { getEffectiveSafeBottom } from '../../../../stores/common';

/** 底栏 padding-bottom = 设计底距 + App/env 安全区（px） */
export const addAccountBarPadBottom = (baseBottom = 16) => baseBottom + getEffectiveSafeBottom();

/** 内容区为固定底栏预留：栏身高度 + 安全区（px） */
export const addAccountContentReserve = (barBodyPx: number) =>
  barBodyPx + getEffectiveSafeBottom();
